import * as moment from 'moment/min/moment-with-locales';
import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment);
//moment.locale(window.navigator.userLanguage || window.navigator.language);

export function secondsFormatter(seconds,detailed,superdetailed) {
	if(superdetailed) {
		if(seconds != 0) {
			//Kleiner als eine Minute?
			if(seconds < 60 && seconds > -60) {
	   			return moment.duration({seconds: seconds}).format("ss _");
	   		}
	   		else {
	   			return moment.duration({seconds: seconds}).format("hh _ mm _ ss _");	   			
	   		}
		}
		else {
			return '-'
		}		
	}
	else if(detailed) {
		if(seconds != 0) {
			//Kleiner als eine Minute?
			if(seconds < 60 && seconds > -60) {
	   			return moment.duration({seconds: seconds}).format("ss _");
	   		}
	   		else {
	   			return moment.duration({seconds: seconds}).format("hh _ mm _ ");	   			
	   		}
		}
		else {
			return '-'
		}
	}
	else {
		if(seconds != 0) {
	   		return moment.duration({seconds: seconds}).format("hh _ mm _");
		}
		else {
			return '-'
		}

	}
}
export function dateFormatter(utc) {
	return moment(utc).format("L");
}
export function toIsoDate(date) {
	return moment(date).format("YYYY-MM-DD");
}


// WEBPACK FOOTER //
// ./src/_helpers/DateTime.js